export function escapeHtml(unsafe) {
  return unsafe
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");
}

export function showSuccessMessage(form) {
  const formMessage = document.querySelector(".form-message");
  formMessage.classList.add("success");
  formMessage.style.display = "block";

  if (form === "newsletter") {
    formMessage.textContent = "You're signed up!";
  }

  if (form === "contact") {
    formMessage.textContent = "Your message has been successfully sent!";
  }

  setTimeout(() => {
    formMessage.style.display = "none";
    formMessage.textContent = "";
  }, 5000);
}
